import React from 'react';

import OverviewChannelIcon from './OverviewChannelIcon';

import './index.scss';
import iconServiceWebchat from '../../../../assets/images/icon_service_webchat.svg';
import iconServiceWhats from '../../../../assets/images/icon_service_whats.svg';
import iconServiceFacebook from '../../../../assets/images/icon_service_facebook.svg';
import iconServiceTelegram from '../../../../assets/images/icon_service_telegram.svg';
import iconServiceEmail from '../../../../assets/images/icon_service_email.svg';
import { ChannelId } from '../../../../util/channels';

export default (props) => {
  const { bot } = props;

  const channelWhatsApp = bot.channels.find(
    (i) => i.channelId === ChannelId.WhatsApp
  );
  const channelWebchat = bot.channels.find(
    (i) => i.channelId === ChannelId.WebChat
  );
  const channelFacebook = bot.channels.find(
    (i) => i.channelId === ChannelId.FacebookMessenger
  );

  return (
    <div className="overview-channels">
      <div className="d-flex justify-content-center">
        <OverviewChannelIcon
          icon={iconServiceWebchat}
          active={channelWebchat && channelWebchat.isActive}
        />
        <OverviewChannelIcon
          icon={iconServiceWhats}
          active={channelWhatsApp && channelWhatsApp.isActive}
        />
        <OverviewChannelIcon
          icon={iconServiceFacebook}
          active={channelFacebook && channelFacebook.isActive}
        />
        {/* <OverviewChannelIcon icon={iconServiceTelegram} active={false}/>
        <OverviewChannelIcon icon={iconServiceEmail} active={false}/> */}
      </div>
    </div>
  );
};
